var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 468,
    viewBox: "0 0 424 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_273_1203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1 466.8C29.3725 466.8 37.7 458.473 37.7 448.2C37.7 437.928 29.3725 429.6 19.1 429.6C8.8275 429.6 0.5 437.928 0.5 448.2C0.5 458.473 8.8275 466.8 19.1 466.8Z",
    stroke: "#FF974A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.101 385C144.328 385 166.401 362.928 166.401 335.7C166.401 308.472 144.328 286.4 117.101 286.4C89.8731 286.4 67.8008 308.472 67.8008 335.7C67.8008 362.928 89.8731 385 117.101 385Z",
    stroke: "#FF974A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.2 303.4C259.438 303.4 295.3 267.538 295.3 223.3C295.3 179.062 259.438 143.2 215.2 143.2C170.962 143.2 135.1 179.062 135.1 223.3C135.1 267.538 170.962 303.4 215.2 303.4Z",
    stroke: "#FF974A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2 221.6C374.394 221.6 424 171.993 424 110.8C424 49.6069 374.394 0 313.2 0C252.007 0 202.4 49.6069 202.4 110.8C202.4 171.993 252.007 221.6 313.2 221.6Z",
    fill: "#791229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2 220.1C293.6 177.3 258.4 143.2 215.2 143.2C212.6 143.2 210 143.3 207.4 143.6",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5 193.5L6.5 462.8",
    stroke: "#FF974A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5 28L241.5 193",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_273_1203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 467.3,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.2263945e1575c6c5a92ec63db12f4c9a.svg";
export { ForwardRef as ReactComponent };